// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@37signals/lexxy"
import "@rails/activestorage"
import "./controllers"
